<template>
  <!-- 盒子管理-保低配置-总览 -->
  <div v-if="$route.query.pv" class="case_guaranteed_overview-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-date-picker
            style="width: 200px"
            v-model="query.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          -
          <el-date-picker
            style="width: 200px"
            v-model="query.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="unpack_amount" label="开箱金额" align="center">
        </el-table-column>
        <el-table-column
          prop="unpack_prize_amount"
          label="出奖金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="hope_profit"
          label="期望利润"
          align="center"
        >
        </el-table-column>
        <el-table-column label="计算利润" align="center">
          <template slot-scope="{ row }">
            <span>{{ (row.unpack_amount - row.unpack_prize_amount).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="real_profit"
          label="实际利润"
          align="center"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  data() {
    return {
      loading: false,//加载动画
      query: {
        page: 1,
        start_time: '',
        end_time: ''
      },
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('bottom_record', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    width: 800px;
  }
}
</style>